import React, { useEffect ,useRef} from 'react'
import "./Intro.scss"
import { init } from "ityped";

export default function Intro() {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      backDelay: 1500,
      backSpeed:60,
      strings: ["Full Stack Web Developer", "Competative Coding", "Computer Engineering"],
    });
  }, []);
  return (
    <div className='intro' id='intro'>



      
      <div className="left">
        <div className="imgContainer">
          <img src="assets/mr.jpg" alt="" srcset="" /></div>
      </div>

      <div className="right">
        <div className="wrapper">
          <h2>Hi There, I'm</h2>
          <h1>Bhushan Mali</h1>
          <h3>👩‍💻 <span ref={textRef} ></span></h3>
        </div>
     
        <a href="#portfolio">
          <img src="assets/down.png" alt="" />
        </a>

      </div>
    </div>
  )
}
